import { useIntl } from '@weenat/wintl';
import moment from 'moment-timezone';
import React, { useRef, useState } from 'react';
import { useClient } from '../../../ClientProvider';
import { DecitraitDiseaseId } from '../../../resources/decitrait';
import schemas from '../../../schemas';
import useMutation from '../../../useMutation';
import useOrderedFields from '../../useOrderedFields';
const defaultDiseaseSanitaryState = { leaves: 2, grapes: 2 };
const defaultDiseaseFieldsStatus = { leaves: false, grapes: false };
export const useDecitraitCreateSanitaryStateNote = ({ plotId, handleError, handleSuccess }) => {
    const { t } = useIntl();
    const formRef = useRef();
    const [currentDiseaseId, setCurrentDiseaseId] = React.useState(DecitraitDiseaseId.mildew);
    const schema = schemas.decitrait.createSanitaryStateNote;
    const fieldProps = useOrderedFields(['date', 'leaves', 'grapes'], formRef, {
        labelSource: 'dss.decitrait.inputs'
    });
    const [values, setValues] = useState({
        date: new Date(Date.now()),
        [DecitraitDiseaseId.mildew]: defaultDiseaseSanitaryState,
        [DecitraitDiseaseId.oidium]: defaultDiseaseSanitaryState
    });
    const initialValues = { date: values.date, ...values[currentDiseaseId] };
    const client = useClient();
    const [createSanitaryStateNote, createSanitaryStateNoteRequest] = useMutation(client.decitrait.createSanitaryStateNote(), {
        keysToInvalidate: [client.decitrait.summary({ plotId: plotId }).key],
        onError: (x) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const errorMsg = x.fieldErrors?.error?.message?.message;
            if (errorMsg)
                handleError(errorMsg);
        },
        onSuccess: () => {
            handleSuccess();
        }
    });
    const getHiddenNoteValues = (diseaseId) => ({
        grapes: fieldsStatus[diseaseId].grapes ? values[diseaseId].grapes : -1,
        leaves: fieldsStatus[diseaseId].leaves ? values[diseaseId].leaves : -1
    });
    const handleSubmit = () => {
        createSanitaryStateNote({
            plotId: plotId,
            date: moment(values.date).format('DD/MM/YYYY'),
            oidium: getHiddenNoteValues(DecitraitDiseaseId.oidium),
            mildew: getHiddenNoteValues(DecitraitDiseaseId.mildew)
        });
    };
    const ecovitiNoteSliderFieldProps = {
        min: 0,
        max: 5,
        step: 1,
        secondaryLabel: t('dss.decitrait.ecoviti.ecovitiNote')
    };
    const [fieldsStatus, setFieldsStatus] = useState({
        [DecitraitDiseaseId.mildew]: defaultDiseaseFieldsStatus,
        [DecitraitDiseaseId.oidium]: defaultDiseaseFieldsStatus
    });
    const handleSliderReveal = (key) => () => {
        setFieldsStatus((x) => ({
            ...x,
            [currentDiseaseId]: { ...x[currentDiseaseId], [key]: !x[currentDiseaseId][key] }
        }));
    };
    return {
        formRef,
        currentDiseaseId,
        setCurrentDiseaseId,
        schema,
        initialValues,
        values,
        setValues,
        handleSubmit,
        fieldProps,
        ecovitiNoteSliderFieldProps,
        fieldsStatus,
        handleSliderReveal,
        createSanitaryStateNoteRequest
    };
};
